import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import theme from '../../../../assets/stylesheets/_settings.global.scss';
import { createContributorCTA, updateContributorCTA } from '../../../services/lwadmin/profile/contributor-cta-service';
import { createCompanyCTA, updateCompanyCTA } from '../../../services/lwadmin/company/company-service';
import { Container, ContentContainer } from '../shared/styles';
import CompaniesContext, { reducer, defaultState } from '../companies/companies-components/context';
import EditCompanyModal from '../companies/companies-components/edit-company-modal';
import BrandCompanyModal from '../companies/companies-components/brand-company-modal';
import CTAModal from '../companies/companies-components/cta-modal';
import Action from './company-components/actions';
import { SectionTitle } from './company-components/styles';
import ContributorHeader from './company-components/contributor-header';
import Contributor from './company-components/contributor';
import FundHeader from './company-components/fund-header';
import Fund from './company-components/fund';
import PartnerHeader from './company-components/partner-header';
import Partner from './company-components/partner';

export default function Company({ company }) {
  const [state, dispatch] = React.useReducer(reducer, defaultState);

  const { name, members, funds } = company;

  return (
    <ThemeProvider theme={theme}>
      <CompaniesContext.Provider value={{ state, dispatch }}>
        <Container>
          <ContentContainer>
            <h1>{name}</h1>
            <SectionTitle>Team Members - Contributors</SectionTitle>
            <ContributorHeader />
            {members.filter(m => m.role === 'contributor' || m.role === 'editor').map(member => <Contributor key={member.id} member={member} />)}
            <SectionTitle>Team Members - Partners</SectionTitle>
            <PartnerHeader />
            {members.filter(m => m.role === 'partner').map(member => <Partner key={member.id} member={member} />)}
            <SectionTitle>Funds</SectionTitle>
            <FundHeader />
            {funds.map(fund => <Fund key={fund.id} fund={fund} />)}
            <EditCompanyModal />
            <BrandCompanyModal />
            <CTAModal
              type="contributor"
              title="Create Contributor CTA"
              description="Create a CTA preset for this contributor. This CTA can be added to a wire from the Preset List in the Wire Editor. Changing a Preset from the Editor will not alter this default. Previously published wires remain unaffected."
              createFunction={createContributorCTA}
              updateFunction={updateContributorCTA}
            />
            <CTAModal
              type="company"
              title="Create Company CTA"
              description="Create a CTA preset for all Company contributors. This CTA can be added to a wire from the Preset List in the Wire Editor. Changing a Preset from the Editor will not alter this default. Previously published wires remain unaffected."
              dispatchEvent="companyUpdated"
              createFunction={createCompanyCTA}
              updateFunction={updateCompanyCTA}
            />
          </ContentContainer>
          <Action company={company} />
        </Container>
      </CompaniesContext.Provider>
    </ThemeProvider>
  );
}

Company.propTypes = {
  company: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    administratorEmail: PropTypes.string,
    websiteUrl: PropTypes.string,
    members: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      slug: PropTypes.string,
      name: PropTypes.string,
      position: PropTypes.string,
      userId: PropTypes.number,
      role: PropTypes.string,
      cta: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        description: PropTypes.string,
        url: PropTypes.string,
      }),
    })),
    funds: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      published: PropTypes.bool,
      publicUrl: PropTypes.string,
    })),
  }).isRequired,
};
